@if (posts.length) {
<section id="learn" class="bg-ground pb-[112px]">
  <div class="mx-auto max-w-[1180px] px-8">
    <div class="max-w-[38ch]">
      <p
        class="text-kicker uppercase text-accent reveal"
        appReveal
        i18n="@@learnKicker"
      >
        Learn
      </p>
      <h2
        class="mt-kicker-gap text-headline text-ink text-balance reveal"
        appReveal
        i18n="@@learnHeadline"
      >
        What we have written down.
      </h2>
      <p class="mt-8 text-body text-ink-2 reveal" appReveal i18n="@@learnIntro">
        Short pieces on budgeting by hand, and on what the app does with your
        records.
      </p>
    </div>

    <ul
      class="mt-[42px] grid gap-8 reveal sm:grid-cols-2 lg:grid-cols-3"
      appReveal
    >
      @for (post of posts; track post.slug) {
      <li class="flex">
        <app-post-card [post]="post" />
      </li>
      }
    </ul>

    <p class="mt-11 reveal" appReveal>
      <a routerLink="/blog" class="text-label text-accent" i18n="@@learnAll"
        >All posts</a
      >
    </p>
  </div>
</section>
}
